import { createFileRoute, redirect } from "@tanstack/react-router"
import { hasAdminRole } from "@/lib/auth-roles"
import { queryClient } from "../../query-client"
import { meQueryOptions } from "../../me"

/**
 * /persona-management → /persona-management/<PIC>: quản trị vào "all" (thấy mọi
 * lượt tư vấn), PIC vào trang của chính mình. Giữ nguyên ?tab=… của link cũ.
 */
export const Route = createFileRoute("/persona-management/")({
  beforeLoad: async ({ location }) => {
    const user = await queryClient.ensureQueryData(meQueryOptions)
    if (!user) throw redirect({ href: "/" })
    const picId = hasAdminRole(user.role) ? "all" : user.id
    throw redirect({ href: `/persona-management/${picId}${location.searchStr ?? ""}`, replace: true })
  },
})
